// extracted by mini-css-extract-plugin
export default {"Chip":"Chip_Chip__Bvy60"};